<template>
  <div>
    <custom-toolbar
      :title="'Détails du retrait'"
      @refresh="refreshObjet"
    />
    <v-row class="mt-1" >
      <v-col
        cols="12"
        lg="6"
        md="6"
      >
        <v-skeleton-loader
          v-show="isDialogVisible"
          boilerplate
          class="mx-auto"
          elevation="2"
          max-width="600"
          type="card-avatar, article, article, actions"
        ></v-skeleton-loader>
        <withdrawal-panel v-if="!isDialogVisible && withdrawal" :withdrawal="withdrawal"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, ref, computed } from '@vue/composition-api'
import LoaderDialog from '@core/components/dialogs/LoaderDialog'
import WithdrawalPanel from '@core/components/withdrawal/WithdrawalPanel'
import store from '@/store'
import router from '@/router'
import CustomToolbar from "@core/components/toolbar/CustomToolbar";

export default {
  name: 'WithdrawalDetails',
  components: {
    CustomToolbar,
    WithdrawalPanel, LoaderDialog,
  },
  setup() {
    const isDialogVisible = ref(false)
    const route = getCurrentInstance().proxy.$route

    const withdrawal = computed(() => store.state.withdraw.withdraw)

    const getWithdrawal = () => {
      const id = route.params.id !== undefined ? route.params.id : null
      if (id !== null) {
          isDialogVisible.value = true
          store.dispatch('withdraw/getWithdrawalById', id).then(() => {
            isDialogVisible.value = false
          }).catch(error => {
            console.log(error)
            router.back()
          })
      }
    }

    const refreshObjet = () => {
      getWithdrawal()
    }

    onMounted(getWithdrawal)

    return {
      isDialogVisible,
      withdrawal,
      refreshObjet,
    }
  },
}
</script>
